import { render, staticRenderFns } from "./ProductDetailsNavigation.vue?vue&type=template&id=6d19b32e&scoped=true"
import script from "./ProductDetailsNavigation.vue?vue&type=script&lang=js"
export * from "./ProductDetailsNavigation.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsNavigation.vue?vue&type=style&index=0&id=6d19b32e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19b32e",
  null
  
)

export default component.exports